module.exports = __webpack_public_path__ + "./images/p13.JPG?6ccf8e3df312f6c68fa0f3c73f0589a9";


//////////////////
// WEBPACK FOOTER
// ./src/products/p13.JPG
// module id = 48
// module chunks = 0